import { typography as ionTypography } from './ion/typography'

export const typography = {
  align: {
    center: 'center',
    left: 'left',
    right: 'right',
  },
  decoration: {
    lineThrough: 'line-through',
    none: 'none',
    underline: 'underline',
    uppercase: 'uppercase',
  },
  family: {
    bold: 'Manrope Bold',
    medium: 'Manrope Medium',
    primary: 'Manrope',
  },
  ion: ionTypography,
  lineHeight: {
    lg: '140%',
    md: '124%',
    sm: '100%',
  },
  sizes: {
    '2md': '22px',
    '2xl': '40px',
    '2xs': '12px',
    '3md': '26px',
    '3xl': '60px',
    '3xs': '10px',
    lg: '30px',
    md: '18px',
    sm: '16px',
    xl: '36px',
    xm: '20px',
    xs: '14px',
  },
  weight: {
    lg: '700',
    md: '600',
    sm: '500',
    xl: '800',
    xsm: '400',
  },
} as const
